module.exports = __webpack_public_path__ + "img/1F1F9-1F1E8.518919a4.svg";